var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlmonds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "almonds",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "amandelen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "amandelen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fontStyle: "condensed",
    fontWeight: "bold",
    "line-spacing": 22,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 99
  }, "amandelen")), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(28.605551, 19.412941)",
    fill: "#161615"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4401995,31.2209502 C22.2612036,34.1568024 18.1499482,35.8400476 14.1590694,35.8400476 C10.8596969,35.8400476 7.89333698,34.6922613 5.71425741,32.6141916 C5.21605656,30.7658538 2.72768828,18.5315348 21.3781491,10.6848344 C31.8957227,6.25790815 36.3171454,4.41743193 37.5613296,3.90031664 C37.0306183,9.29159298 34.4561412,22.8955686 25.4401995,31.2209502 Z M2.16710248,23.338436 C2.35952927,19.2224777 4.36814858,15.1764 7.67806501,12.2370537 C16.0719147,4.78081024 30.9994884,2.90976133 36.4559739,2.46514699 C34.7689446,3.16831897 30.2403252,5.05771151 20.6936721,9.0758371 C5.59300218,15.4288431 3.53957115,24.8871613 3.64325316,29.9255414 C2.57831589,27.9907266 2.05463386,25.7327147 2.16710248,23.338436 Z M39.1534635,0.867505315 C38.9812459,0.682322136 38.7352208,0.584489512 38.4821664,0.587058729 C37.6245932,0.61244169 17.3407013,1.31124614 6.50680974,10.9337834 C2.84806485,14.1840976 0.625930885,18.6756633 0.411537572,23.2563264 C0.230533382,27.1259561 1.49229075,30.7143169 3.96484313,33.3610388 C4.04919459,33.4510099 4.14496866,33.5287519 4.23107745,33.6169759 C4.29170506,33.6990855 4.36463394,33.7672189 4.44722808,33.8239968 C6.96019887,36.2462277 10.3737973,37.5870587 14.1590694,37.5870587 C18.5884001,37.5870587 23.13635,35.7334799 26.6369359,32.5006358 C38.1834217,21.8386269 40.1955556,1.98908646 39.1534635,0.867505315 L39.1534635,0.867505315 Z",
    id: "Fill-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9853756,29.7342795 C14.9673503,33.5579629 9.90433999,31.342635 9.6924125,31.246457 C9.25246177,31.0460187 8.71683069,31.2044296 8.49238428,31.6004568 C8.26793786,31.9972923 8.44230858,32.4846482 8.88225932,32.6875112 C9.01996747,32.7513605 10.8906523,33.5870587 13.702939,33.5870587 C15.9921136,33.5870587 18.9054459,33.0326206 22.0146099,31.0573338 C22.4187923,30.8003202 22.5153669,30.2967999 22.2319027,29.9314849 C21.9457559,29.5653618 21.3886638,29.477266 20.9853756,29.7342795",
    id: "Fill-61"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlmonds);
export default __webpack_public_path__ + "static/media/almonds.9e27f242324afd9bd14a14953a9ea0cf.svg";
export { ForwardRef as ReactComponent };